import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, Routes, RouterModule, PreloadingStrategy, PreloadAllModules } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectModule } from 'ng-select';
import { ClipboardModule } from 'ngx-clipboard';
import { MainPipeModule } from '../app.pipes';

import { UserService } from '../services/user.service';
import { StoreService } from '../services/store.service';
import { StoreComponent } from './store/store.component';
import { ProductComponent } from './product/product.component';
import { CartButtonComponent } from './_partials/cart-button/cartbutton.component';
import { ShareMenuComponent } from './_partials/share-menu/share.menu.component';
import { ProductFeaturesComponent } from './_partials/product-features/product.features.component';
import { ItemComponent } from './item/item.component';
import { CategoryComponent } from './categories/categories.component';
import { CheckoutComponent } from './checkout/checkout.component'
import { ReCaptchaModule } from 'angular2-recaptcha';
import { CustomizeComponent } from './customize/customize.component';
import { MatchHeightDirective } from './store.matchheight.directive';
import { LoginPanelComponent } from '../user/login/login.panel.component';
import { PopularComponent } from './popular/popular.component';
import { BrowserComponent } from './browser/browser.component';
import { CheckoutThankyouComponent } from './checkout/thankyou/checkout.thankyou';

import { ItemsComponent } from '../store/items/items.component';
import { ProductsComponent } from '../store/products/products.component';

export const StoreRoutes = [
  { path: 'shop',                   component: StoreComponent, data: { title: 'Shop Identity RPG' } },
  { path: 'store',                  component: StoreComponent, data: { title: 'Shop Identity RPG' } },
  { path: 'categories',             component: CategoryComponent, data: { title: 'Identity RPG | Shop by Category' } },
  { path: 'shop/categories',        component: CategoryComponent, data: { title: 'Identity RPG | Shop by Category' } },
  { path: 'shop/category/:id',      component: CategoryComponent, data: { title: 'Identity RPG | Shop by Category' } },
  { path: 'shop/categories/:id',    component: CategoryComponent, data: { title: 'Identity RPG | Shop by Category' } },
  { path: 'shop/product/:id',       component: ProductComponent, data: { title: 'Identity RPG | Online Shop' } },
  { path: 'shop/popular',           component: PopularComponent, data: { title: 'Identity RPG | Popular Items' } },
  { path: 'product/:id',            component: ProductComponent, data: { title: 'Identity RPG | Online Shop' } },
  { path: 'shop/products',          component: ProductsComponent, data: { title: 'Identity RPG | Products' } },
  { path: 'products',               component: ProductsComponent, data: { title: 'Identity RPG | Products' } },
  { path: 'browse',                 component: BrowserComponent, data: { title: 'Identity RPG | Shop Categories' } },
  { path: 'shop/browse',            component: BrowserComponent, data: { title: 'Identity RPG | Shop Categories' } },
  { path: 'browser',                component: BrowserComponent, data: { title: 'Identity RPG | Shop Categories' } },
  { path: 'popular',                component: PopularComponent, data: { title: 'Identity RPG | Popular Items' } },
  { path: 'shop/item/:id',          component: ItemComponent, data: { title: 'Game Item | Identity RPG' } },
  { path: 'item/:id',               component: ItemComponent, data: { title: 'Game Item | Identity RPG' } },
  { path: 'items',                  component: ItemsComponent, data: { title: 'Identity RPG | Items' } },
  { path: 'checkout',               component: CheckoutComponent, data: { title: 'Checkout | Identity RPG' } },
  { path: 'shop/items',             component: ItemsComponent, data: { title: 'Identity RPG | Items' } },
  { path: 'shop/checkout',          component: CheckoutComponent, data: { title: 'Checkout | Identity RPG' } },
  { path: 'shop/thankyou',          component: CheckoutThankyouComponent, data: { title: 'Checkout | Identity RPG' } },
  { path: 'thankyou',               component: CheckoutThankyouComponent, data: { title: 'Thank you! | Identity RPG' } },
  { path: 'customize',              component: CustomizeComponent, data: { title: 'Build your Identity - Identity Online RPG' } }
];


@NgModule({
  schemas: [ 
    CUSTOM_ELEMENTS_SCHEMA
  ],
  declarations: [
    ItemComponent,
    ItemsComponent,
    StoreComponent,
    PopularComponent,
    ProductComponent,
    CheckoutComponent,
    CustomizeComponent,
    LoginPanelComponent,
    CategoryComponent,
    BrowserComponent,
    ProductsComponent,
    ShareMenuComponent,
    CartButtonComponent,
    MatchHeightDirective,
    ProductFeaturesComponent,
    CheckoutThankyouComponent
  ],
  providers: [
    UserService,
	  StoreService
  ],
  imports: [
    BrowserModule,
    SelectModule,
    FormsModule,
    MainPipeModule,
    ReCaptchaModule,
    ClipboardModule,
    RouterModule.forChild(StoreRoutes)
  ],
  exports: [
    LoginPanelComponent,
    CommonModule,
    RouterModule
  ]
})
export class StoreModule{ }


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/store.module.ts